/**
 * Normalize blog HTML from API (string, legacy array, or empty).
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeBlogContentHtml(raw) {
  if (raw == null) return '';
  if (typeof raw === 'string') return raw;
  if (Array.isArray(raw)) return raw.filter(Boolean).join('\n');
  return String(raw);
}

/** @param {unknown} raw */
export function hasBlogContentHtml(raw) {
  return Boolean(normalizeBlogContentHtml(raw).trim());
}
